module.exports = __webpack_public_path__ + "static/media/eyelet04.1ed19906.webp";